const exchangeInfo = {
    'AMEX': {
        fullName: 'New York Stock Exchange Arca',
        description: 'Part of the NYSE Group, NYSE Arca is an electronic securities exchange known for listing small to medium-sized companies and ETF trading.'
    },
    'AMS': {
        fullName: 'Euronext Amsterdam',
        description: 'Part of the Euronext group, Euronext Amsterdam is one of the oldest stock exchanges in the world, known for its long history and diverse listings.'
    },
    'AQS': {
        fullName: 'Aquis Stock Exchange',
        description: 'A pan-European exchange known for its subscription-based trading model and technology focus.'
    },
    'ASX': {
        fullName: 'Australian Securities Exchange',
        description: 'One of the largest exchanges in the Asia-Pacific region, known for its mining and resources companies listings.'
    },
    'ATH': {
        fullName: 'Athens Stock Exchange',
        description: 'Greece\'s principal stock exchange, central to the country\'s capital markets and economy.'
    },
    'BER': {
        fullName: 'Berlin Stock Exchange',
        description: 'A regional German exchange known for its specialist trading and retail focus.'
    },
    'BME': {
        fullName: 'Madrid Stock Exchange',
        description: 'Spain\'s largest stock exchange, known for its IBEX 35 index and diverse sectors.'
    },
    'BRU': {
        fullName: 'Euronext Brussels',
        description: 'Belgium\'s primary stock exchange, part of the Euronext group, known for its diverse listing offerings.'
    },
    'BSE': {
        fullName: 'Bombay Stock Exchange',
        description: 'Asia\'s oldest stock exchange and one of India\'s leading exchange groups. Known for its benchmark SENSEX index.'
    },
    'BUD': {
        fullName: 'Budapest Stock Exchange',
        description: 'Hungary\'s principal stock exchange, central to the country\'s capital markets.'
    },
    'BUE': {
        fullName: 'Buenos Aires Stock Exchange',
        description: 'Argentina\'s main stock exchange, important for South American market access.'
    },
    'BVC': {
        fullName: 'Colombia Stock Exchange',
        description: 'Colombia\'s principal securities exchange, central to the Andean region\'s capital markets.'
    },
    'CBOE': {
        fullName: 'Chicago Board Options Exchange',
        description: 'The world\'s largest options exchange, known for its VIX volatility index and broad range of options and futures products.'
    },
    'CNQ': {
        fullName: 'Canadian Securities Exchange',
        description: 'A Canadian stock exchange offering streamlined listing and trading services, particularly for emerging and growth-stage companies.'
    },
    'CPH': {
        fullName: 'NASDAQ Copenhagen',
        description: 'Denmark\'s principal stock exchange, part of the NASDAQ Nordic group.'
    },
    'DFM': {
        fullName: 'Dubai Financial Market',
        description: 'The United Arab Emirates\' leading financial market, known for its Islamic financial products.'
    },
    'DOH': {
        fullName: 'Qatar Stock Exchange',
        description: 'Qatar\'s principal stock market, important for Gulf region investments.'
    },
    'DUB': {
        fullName: 'Euronext Dublin',
        description: 'Ireland\'s principal securities market, part of the Euronext group, known for its international listings.'
    },
    'DUS': {
        fullName: 'Dusseldorf Stock Exchange',
        description: 'A regional German exchange specializing in private investor services.'
    },
    'DXE': {
        fullName: 'CBOE Europe',
        description: 'A pan-European exchange owned by CBOE Global Markets, focusing on equities trading.'
    },
    'EGX': {
        fullName: 'Egyptian Exchange',
        description: 'Egypt\'s primary securities market, one of the oldest exchanges in the Middle East.'
    },
    'EURONEXT': {
        fullName: 'Euronext',
        description: 'A pan-European exchange operating markets in multiple European countries.'
    },
    'FSX': {
        fullName: 'Frankfurt Stock Exchange',
        description: 'One of Europe\'s largest trading venues, known for its electronic trading system and international securities listings.'
    },
    'HAM': {
        fullName: 'Hamburg Stock Exchange',
        description: 'A regional German exchange with a focus on local and international securities.'
    },
    'HEL': {
        fullName: 'NASDAQ Helsinki',
        description: 'Finland\'s main stock exchange, part of the NASDAQ Nordic group.'
    },
    'HKSE': {
        fullName: 'Hong Kong Stock Exchange',
        description: 'A major Asian financial hub, particularly important for Chinese company listings and international investment in Asia.'
    },
    'HOSE': {
        fullName: 'Ho Chi Minh Stock Exchange',
        description: 'Vietnam\'s principal stock exchange, central to the country\'s rapidly growing capital markets.'
    },
    'ICE': {
        fullName: 'NASDAQ Iceland',
        description: 'Iceland\'s principal stock exchange, part of the NASDAQ Nordic group.'
    },
    'IOB': {
        fullName: 'International Order Book',
        description: 'A London Stock Exchange platform enabling trading of international securities via depositary receipts.'
    },
    'IST': {
        fullName: 'Istanbul Stock Exchange',
        description: 'Turkey\'s sole exchange entity, combining former Istanbul exchanges.'
    },
    'JKT': {
        fullName: 'Indonesia Stock Exchange',
        description: 'Indonesia\'s main securities exchange, important for Southeast Asian markets.'
    },
    'JNB': {
        fullName: 'Johannesburg Stock Exchange',
        description: 'Africa\'s largest stock exchange, known for its mining sector and role in the continent\'s economic development.'
    },
    'JPX': {
        fullName: 'Tokyo Stock Exchange',
        description: 'Japan\'s largest stock exchange and one of Asia\'s most significant trading venues, known for its industrial and technology sectors.'
    },
    'KLS': {
        fullName: 'Malaysian Stock Exchange',
        description: 'Malaysia\'s integrated exchange, known for its Islamic financial products.'
    },
    'KOE': {
        fullName: 'KOSDAQ',
        description: 'South Korea\'s technology-focused securities exchange, similar to NASDAQ, known for its growth and tech company listings.'
    },
    'KSC': {
        fullName: 'Korea Exchange',
        description: 'South Korea\'s main securities exchange, known for its technology sector and robust trading infrastructure.'
    },
    'KUW': {
        fullName: 'Kuwait Stock Exchange',
        description: 'Kuwait\'s principal stock exchange, one of the oldest and largest in the Gulf region.'
    },
    'LIS': {
        fullName: 'Euronext Lisbon',
        description: 'Portugal\'s primary stock exchange, part of the Euronext group.'
    },
    'LSE': {
        fullName: 'London Stock Exchange',
        description: 'One of the world\'s oldest stock exchanges and Europe\'s largest, known for its international listings and financial innovation.'
    },
    'MCX': {
        fullName: 'Moscow Stock Exchange',
        description: 'Russia\'s largest exchange group, trading multiple asset classes.'
    },
    'MEX': {
        fullName: 'Mexican Stock Exchange',
        description: 'Mexico\'s principal securities exchange, important for Latin American markets.'
    },
    'MIL': {
        fullName: 'Italian Stock Exchange',
        description: 'Italy\'s main stock exchange, known for its industrial and luxury goods sectors.'
    },
    'MUN': {
        fullName: 'Munich Stock Exchange',
        description: 'A regional German exchange focusing on retail investors and local securities.'
    },
    'NASDAQ': {
        fullName: 'National Association of Securities Dealers Automated Quotations',
        description: 'The NASDAQ is an American stock exchange, the second-largest in the world by market capitalization. It is known for its technology and growth companies.'
    },
    'NEO': {
        fullName: 'CBOE CA',
        description: 'A Canadian stock exchange operated by CBOE, offering modern trading infrastructure for Canadian and international listings.'
    },
    'NSE': {
        fullName: 'National Stock Exchange of India',
        description: 'India\'s leading stock exchange, known for its technology and modern trading systems.'
    },
    'NYSE': {
        fullName: 'New York Stock Exchange',
        description: 'The NYSE is the world\'s largest stock exchange by market capitalization. It\'s known for its trading floor and iconic bell ringing ceremonies.'
    },
    'NZE': {
        fullName: 'New Zealand Exchange',
        description: 'New Zealand\'s principal securities market, known for its dairy and agricultural sectors.'
    },
    'OSL': {
        fullName: 'Oslo Stock Exchange',
        description: 'Norway\'s principal stock exchange, known for its energy and shipping sectors.'
    },
    'OTC': {
        fullName: 'Other OTC',
        description: 'A U.S. over-the-counter market for trading securities not listed on formal exchanges.'
    },
    'PAR': {
        fullName: 'Euronext Paris',
        description: 'France\'s primary stock exchange, part of the Euronext group, one of the largest in Europe.'
    },
    'PNK': {
        fullName: 'OTC Markets US Pink Slips',
        description: 'A U.S. market for trading over-the-counter stocks with varying levels of disclosure.'
    },
    'PRA': {
        fullName: 'Prague Stock Exchange',
        description: 'The Czech Republic\'s major stock exchange, central to Eastern European markets.'
    },
    'RIS': {
        fullName: 'NASDAQ Riga',
        description: 'Latvia\'s principal stock exchange, part of the NASDAQ Baltic market.'
    },
    'SAO': {
        fullName: 'B3 S.A.',
        description: 'The main securities trading center in Brazil, featuring prominent Latin American companies and a strong commodities sector.'
    },
    'SAU': {
        fullName: 'Saudi Exchange',
        description: 'Saudi Arabia\'s sole stock exchange, known as Tadawul, the largest in the Arab world.'
    },
    'SES': {
        fullName: 'Stock Exchange of Singapore',
        description: 'Singapore\'s principal stock exchange, a major financial hub for Southeast Asian markets.'
    },
    'SET': {
        fullName: 'Stock Exchange of Thailand',
        description: 'Thailand\'s main stock exchange, important for Southeast Asian investments.'
    },
    'SGO': {
        fullName: 'Santiago Stock Exchange',
        description: 'Chile\'s principal stock exchange, one of the largest and most modern in Latin America.'
    },
    'SHH': {
        fullName: 'Shanghai Stock Exchange',
        description: 'One of mainland China\'s two main exchanges, known for larger company listings.'
    },
    'SHZ': {
        fullName: 'Shenzhen Stock Exchange',
        description: 'One of mainland China\'s major exchanges, known for its focus on smaller, growing enterprises and tech companies.'
    },
    'SIX': {
        fullName: 'Swiss Exchange',
        description: 'Switzerland\'s principal stock exchange, known for its stability and strong presence in financial services sector.'
    },
    'STO': {
        fullName: 'Stockholm Stock Exchange',
        description: 'Sweden\'s primary stock exchange, part of the NASDAQ Nordic group.'
    },
    'STU': {
        fullName: 'Stuttgart Stock Exchange',
        description: 'Germany\'s second-largest exchange, known for retail investor focus.'
    },
    'TAI': {
        fullName: 'Taiwan Stock Exchange',
        description: 'Taiwan\'s principal exchange, known for its technology sector listings.'
    },
    'TAL': {
        fullName: 'NASDAQ Tallinn',
        description: 'Estonia\'s principal stock exchange, part of the NASDAQ Baltic market.'
    },
    'TLV': {
        fullName: 'Tel Aviv Stock Exchange',
        description: 'The Tel Aviv Stock Exchange is Israel\'s only public stock exchange. It plays a significant role in the country\'s economy and is known for its technology sector.'
    },
    'TSX': {
        fullName: 'Toronto Stock Exchange',
        description: 'Canada\'s largest stock exchange, known for its resource and mining company listings.'
    },
    'TSXV': {
        fullName: 'Toronto Stock Exchange Ventures',
        description: 'Canada\'s venture exchange for emerging companies, part of the TMX Group.'
    },
    'TWO': {
        fullName: 'Taipei Exchange',
        description: 'Taiwan\'s over-the-counter market, focusing on smaller companies and startups.'
    },
    'VIE': {
        fullName: 'Vienna Stock Exchange',
        description: 'Austria\'s principal stock exchange, important for Central European markets.'
    },
    'WSE': {
        fullName: 'Warsaw Stock Exchange',
        description: 'Poland\'s principal stock exchange, largest in Central and Eastern Europe.'
    },
    'XETRA': {
        fullName: 'Deutsche Börse',
        description: 'A German electronic trading system operated by Deutsche Börse, known for its efficiency and speed in executing trades.'
    }
};

export default exchangeInfo;